"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sizes = void 0;

var _designLanguage = require("@doordash/design-language");

var Sizes = {
  Small: _designLanguage.Inset.Sizes.XSmall,
  Medium: _designLanguage.Inset.Sizes.Small,
  Large: _designLanguage.Inset.Sizes.Large
};
exports.Sizes = Sizes;